/* eslint-disable react/no-danger */
import React from 'react'

import { string } from 'prop-types'

function SearchAdvancedTipsRow({ code, example, description }) {
  return (
    <div className="advanced-tips__row">
      <div className="advanced-tips__top-section">
        <div className="advanced-tips__column advanced-tips__column--syntax">
          <div className="advanced-tips__mobile-header">Syntax</div>
          <code className="advanced-tips__code">{code}</code>
        </div>
        <div className="advanced-tips__column advanced-tips__column--example">
          <div className="advanced-tips__mobile-header">Example</div>
          {example}
        </div>
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: description }}
        className="advanced-tips__column advanced-tips__column--description"
      />
    </div>
  )
}

SearchAdvancedTipsRow.propTypes = {
  code: string.isRequired,
  description: string.isRequired,
  example: string.isRequired,
}

export default SearchAdvancedTipsRow
